import { render, staticRenderFns } from "./JTMSModule.vue?vue&type=template&id=47ddfb5c&"
import script from "./JTMSModule.vue?vue&type=script&lang=ts&"
export * from "./JTMSModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports